import styled from "styled-components";
import { Link } from "react-router-dom";

import Menu from "../assets/vectors/menu.svg";
import Logo from "../assets/images/ki_logo_02_beyaz.png";

const HeaderWrapper = styled.div`
  background: #315c89;
  display: flex;
  position: fixed;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 50px;
  width: calc(100% - 100px);
  z-index: 99;
  @media (max-width: 768px) {
    padding: 0 35px 0 15px;
    width: calc(100% - 50px);
  }
`;
const Sm = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
const LogoImage = styled.img`
  height: 80px;
`;
const Dropdown = styled.div`
  float: left;
  overflow: hidden;

  & > .dropdown-content {
    display: none;
    position: absolute;
    right: 42px;
    background: #1d4666;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  & > .dropbtn {
    margin: 20px 10px;
    border: none;
    outline: none;
    background: inherit;
    font-family: inherit;
    margin: 0;
  }

  &:hover .dropdown-content {
    display: block;
  }
`;
const NavbarItems = styled.div`
  font-size: 15px;
  line-height: 25px;
  color: #fff;
  margin: 10px;

  & > a {
    font-size: 15px;
    line-height: 25px;
    color: #fff;
    text-decoration: none;
  }
`;
const Nav = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  & > span {
    color: #fff;
    margin: 0 20px;
    font-size: 15px;
    font-weight: 600;
    & > a {
      color: #fff;
      margin: 0px;
      font-size: 15px;
      font-weight: 600;
      text-decoration: none;
    }
  }
`;
function Header() {
  return (
    <HeaderWrapper>
      <a href="/">
        <LogoImage src={Logo} alt="" />
      </a>
      <Nav>
        <span>
          <Link to="/tanitim">Tanıtım</Link>
        </span>
        <span>
          <Link to="/hakkinda">Hakkında</Link>
        </span>
        <span>
          <Link to="/iletisim">İletişim</Link>
        </span>
      </Nav>
      <Sm name="sm">
        <Dropdown>
          <button className="dropbtn">
            <img src={Menu} alt="" style={{ width: "20px" }} />
          </button>
          <div className="dropdown-content">
            <NavbarItems>
              <Link to="/tanitim">Tanıtım</Link>
            </NavbarItems>
            <NavbarItems>
              <Link to="/hakkinda">Hakkında</Link>
            </NavbarItems>
            <NavbarItems>
              <Link to="/iletisim">İletişim</Link>
            </NavbarItems>
          </div>
        </Dropdown>
      </Sm>
    </HeaderWrapper>
  );
}
export default Header;
